export default __webpack_public_path__ + "media/images/dividers/orange-tear-82644e74e21c1b572a4cb89828076f6c.svg";